import { useLangStore } from "@/store/lang.js";
import type { Language } from "@bongeunsa/i18n";

const footerStrings: Record<Language, {
  name: string;
  address: string;
  tel: string;
  templestay: string;
  copyright: string;
}> = {
  ko: {
    name: "봉은사",
    address: "서울특별시 강남구 봉은사로 531",
    tel: "대표전화: 02-511-0751",
    templestay: "템플스테이 문의: 02-511-0754",
    copyright: "© 봉은사 All rights reserved.",
  },
  en: {
    name: "Bongeunsa",
    address: "531 Bongeunsa-ro, Gangnam-gu, Seoul",
    tel: "Tel: 02-511-0751",
    templestay: "Templestay: 02-511-0754",
    copyright: "© Bongeunsa Buddhist Temple. All rights reserved.",
  },
  zh: {
    name: "奉恩寺",
    address: "首尔特别市江南区奉恩寺路531号",
    tel: "代表电话: 02-511-0751",
    templestay: "寺院寄宿咨询: 02-511-0754",
    copyright: "© 奉恩寺 版权所有。",
  },
  ja: {
    name: "奉恩寺",
    address: "ソウル特別市江南区奉恩寺路531",
    tel: "代表電話: 02-511-0751",
    templestay: "テンプルステイ問合せ: 02-511-0754",
    copyright: "© 奉恩寺 All rights reserved.",
  },
};

export function Footer() {
  const { lang } = useLangStore();
  const s = footerStrings[lang];

  return (
    <footer className="py-10 text-center">
      <div className="flex items-center justify-center gap-2 mb-3">
        <img
          src="/logo-symbol.png"
          alt=""
          className="h-5 w-5 object-contain opacity-25"
          draggable={false}
        />
        <span className="text-sm font-semibold text-gray-400/70">{s.name}</span>
      </div>
      <div className="space-y-1 text-xs text-gray-400/60 leading-relaxed">
        <p>{s.address}</p>
        <p>{s.tel}</p>
        <p>{s.templestay}</p>
      </div>
      <p className="mt-4 text-[11px] text-gray-400/40">{s.copyright}</p>
    </footer>
  );
}
